<template>
  <b-modal :show="show" title="Billing Charge" @hide="close" @hidden="close" hide-footer>
    <b-form @submit.prevent="saveBilling">
      <b-form-group label="Select Booking">
        <b-form-select
          v-model="formData.booking_id"
          :options="bookingOptions"
          required
        />
      </b-form-group>

      <b-form-group label="Room">
        <b-form-input v-model="formData.room_name" type="text" placeholder="Enter room number or name (optional)" />
      </b-form-group>

      <b-form-group label="Item Name">
        <b-form-input v-model="formData.item_name" required />
      </b-form-group>

      <b-form-group label="Description">
        <b-form-textarea v-model="formData.description" rows="3" />
      </b-form-group>

      <b-form-group label="Amount">
        <b-form-input
          v-model.number="formData.amount"
          type="number"
          min="0.01"
          step="0.01"
          required
        />
      </b-form-group>

      <b-form-group label="Quantity">
        <b-form-input v-model.number="formData.quantity" type="number" min="1" required />
      </b-form-group>

      <b-form-group label="Category">
        <b-form-input v-model="formData.category" type="text" placeholder="Enter category name" required />
      </b-form-group>

      <div class="text-right mt-3">
        <b-button variant="secondary" @click="close">Close</b-button>
        <b-button variant="primary" type="submit">Save</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { request } from "@/Util/Request";

export default {
  name: "BillingModal",
  props: {
    show: Boolean,
    billing: Object,
  },
  data() {
    return {
      bookingOptions: [],
      formData: this.billing ? { ...this.billing } : this.defaultBilling(),
    };
  },
  watch: {
    billing: {
      handler(newVal) {
        this.formData = newVal || this.defaultBilling();
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    await this.fetchBookings();
  },
  methods: {
    defaultBilling() {
      return {
        booking_id: "",
        room_name: "",
        item_name: "",
        description: "",
        amount: null,
        quantity: 1,
        category: "",
      };
    },

    async fetchBookings() {
      try {
        const response = await request({
          method: "get",
          url: "/billing/active-bookings",
        });
        this.bookingOptions = response.data.map((booking) => ({
          value: booking.id,
          text: `${booking.user.full_name} (${booking.check_in} to ${booking.check_out})`,
        }));
      } catch (error) {
        console.error("Error fetching bookings:", error);
        this.$toast.error("Failed to load active bookings");
      }
    },


    async saveBilling() {
      try {
        if (this.formData.id) {
          await request({
            method: "put",
            url: `/billings/${this.formData.id}`,
            data: this.formData,
          });
        } else {
          await request({
            method: "post",
            url: "/billings",
            data: this.formData,
          });
        }
        this.$toast.success("Billing charge saved successfully");
        this.$emit("saved");
      } catch (error) {
        console.error("Error saving billing:", error);
        this.$toast.error("Failed to save billing charge");
      }
    },

    close() {
      this.$emit("close");
      this.$emit("update:show", false);
    },
  },
};
</script>

<style scoped></style>

